<div class="content-container">
  <nav class="navbar navbar-expand-sm top-banner" (click)="goToHome()">
    <img src="assets/images/logo.png" width="70" />
    <ul class="navbar-nav">
      <li class="nav-item">
        <div class="contentheader2 text-white">สถาบันคุ้มครองเงินฝาก (สคฝ.)</div>
        <div class="contentheader2">Deposit Protection Agency (DPA)</div>
      </li>
    </ul>
  </nav>

  <div class="news-container">
    <div class="card card-default"
      style="border-bottom-left-radius: 0px; border-bottom-right-radius: 0px; margin-bottom: 0px;">
      <div class="card-body" style="min-height: 100%;">

        <div class="row mb-3" *ngIf="news.img">
          <div class="col-12 text-center">
            <img src="{{news.img}}" style="width: 100% !important;">
          </div>
        </div>

        <h4 class="news-header">{{news.dpa_name}}</h4>
        <br>
        <i>
          <h5 class="news-content">{{ news.dpa_startdate | thaidate:'short'}}</h5>
        </i>
        <hr>
        <div class="news-content" [innerHtml]="news.dpa_detail"></div>
        <hr>

        <div class="row">
          <div class="col-12 p-0">
            <a href="https://th-th.facebook.com/dpathailand" target="_blank" class="mr-2">
              <img src="../../assets/images/facebook-icon.png" width="50">
            </a>
            <a href="https://www.youtube.com/channel/UC0ZTgeKdFlbGumCyE8OPMng" target="_blank" class="mr-2">
              <img src="../../assets/images/youtube-icon.png" width="50">
            </a>
            <a href="https://twitter.com/hashtag/สถาบันคุ้มครองเงินฝาก" target="_blank" class="mr-2">
              <img src="../../assets/images/twitter-icon.png" width="50">
            </a>
            <a href="https://today.line.me/th/v2/article/NRerqp" target="_blank"> 
              <img src="../../assets/images/line-icon.png" width="50">
            </a>
          </div>
        </div>

        <hr>
        <div class="row">
          <div class="col-12 col-md-9">

            <div class="col-12">
              <h4>สถาบันคุ้มครองเงินฝาก</h4>
            </div>

            <div class="col-12">
              <label>อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์
                ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต
                แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900</label>
            </div>

          </div>

          <div class="col-12 col-md-3 text-right my-auto">
            <a href="tel:1158">
              <img src="../../assets/images/img_cc_logo.png" alt="CCLogo" class=""
              onmouseover="this.src='../../assets/images/img_cc_logo2.png'"
              onmouseout="this.src='../../assets/images/img_cc_logo.png'">
            </a>
          </div>

        </div>

      </div>
    </div>

    <div class="row bg-cust-blue" style="height: 5px;"></div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/news/news.component.html